import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
  })
  export class AuthGuard implements CanActivate {
  
    constructor(private authService: AuthService, private router: Router) {}
  
    canActivate(): boolean | UrlTree {
      if (this.authService.isAuthenticated()) {
        return true;
      }
  
      // Redirect to login if not authenticated
      return this.router.parseUrl('/login');
    }
  }